import React, { useEffect, useState, useRef} from 'react'
import AppLayout from '../../../../../../layout/components/AppLayout'
import { useParams } from 'react-router-dom'
import voucherServices from '../voucherServices';

import { useReactToPrint } from 'react-to-print';
import { CancelOutlined, CheckCircle, Print } from '@mui/icons-material';

import SalesVoucherHeader from '../section/SalesVoucherHeader';
import EditVoucherForm from '../component/EditVoucherForm';
import VoucherFooter from '../section/VoucherFooter';
import { CircularProgress, Dialog, DialogContent } from '@mui/material';
import PurchaseVoucherHeader from '../section/PurchaseVoucherHeader';
import VoucherInItemList from '../section/VoucherInItemList';
import VoucherOutItemList from '../section/VoucherOutItemList';
import { useAlert } from '../../../../../../context/AlertContext';
import { useAppData } from '../../../../../../context/AppDataContext';
import FinanceLayout from '../../../../../../layout/components/FinanceLayout';




function ChallanVoucherDetailsPage() {
  const {id} = useParams();

  const printComponentRef = useRef();
  const {AppAlert} = useAlert();

  const [dialogStatus,setDialogStatus] = useState(false);

  const [companyDetails,setCompanyDetails] = useState(null);
  const [partyDetails,setPartyDetails] = useState(null);
  const [voucherDetails,setVoucherDetails] = useState(null);
  const {productList,getProductList} = useAppData();

  const getVoucherDetails = () =>{
    console.log("voucher id is ",id)
    voucherServices.getById(id).then(res=>{
      setVoucherDetails(res.data);
    }).catch(error=>{
      console.log(error);
    })
  }

  useEffect(()=>{
    getVoucherDetails();
    getProductList();
  },[id])

  const [isPrinting,setIsPrinting] = useState(false);


  const finalize =() =>{
    setDialogStatus(true);
    if(voucherDetails.voucherType==="Purchase"){
      voucherServices.purchaseFinalize(id).then(res=>{
        AppAlert(res.msg);
      }).catch(error=>{
        AppAlert(error.msg,"error")
      }).finally(()=>{
        getVoucherDetails();
        setDialogStatus(false);
      })
    }

    if(voucherDetails.voucherType==="Sale"){
      voucherServices.salesFinalize(id).then(res=>{
        AppAlert(res.msg);
      }).catch(error=>{
        AppAlert(error.msg,"error")
      }).finally(()=>{
        getVoucherDetails();
        setDialogStatus(false);
      })
    }

  }

  const discard =() =>{
    setDialogStatus(true);
    if(voucherDetails.voucherType==="Purchase"){
      voucherServices.purchaseFinalizeDiscard(id).then(res=>{
        AppAlert(res.msg);
      }).catch(error=>{
        AppAlert(error.msg,"error")
      }).finally(()=>{
        getVoucherDetails();
        setDialogStatus(false);
      })
    } else {
      voucherServices.salesFinalizeDiscard(id).then(res=>{
        AppAlert(res.msg);
      }).catch(error=>{
        AppAlert(error.msg,"error")
      }).finally(()=>{
        getVoucherDetails();
        setDialogStatus(false);
      })
    }
  }

  const printVoucher = () =>{
    setIsPrinting(true);
    setTimeout(handlePrint,100)
  }

  const handlePrint = useReactToPrint({
    onBeforePrint :() =>{
      setIsPrinting(true);
    },
    onAfterPrint : ()=>{
      setIsPrinting(false);
    },
    content: () => printComponentRef.current,
    // Standard A4 or Letter size logic
    pageStyle: `
        @page { 
            size: auto; 
            margin: 10mm; 
        }
        @media print {
            body { -webkit-print-color-adjust: exact; }
        }
    `
  });

  return (
    <FinanceLayout>
        <style>
          {
            `
            table {page-break-after:unset}
            `
          }
        </style>
        {voucherDetails && 
          <div className='container'>

            <Dialog
              open={dialogStatus}
              keepMounted
              fullWidth={true}
              maxWidth="md"
            >
              <DialogContent>
                <div className='text-center'><CircularProgress /></div>
                <div className='text-center'>Saving In Progress</div>
              </DialogContent>
            </Dialog>
            
            <div className='row'>
              <div className='col-md-12'>
              </div>
              <div className='col-md-12'>
                <div className='row mb-2'>
                  <div className='col-md-12'>
                    {voucherDetails.status === 1 && 
                      <EditVoucherForm data={voucherDetails} callBack={getVoucherDetails} />
                    }
                    {voucherDetails.status === 2 && 
                      <>
                      <button className='btn btn-outline-success ms-2'>Finalized <CheckCircle/> </button>
                      <button className='btn btn-outline-danger float-end ms-2' onClick={discard} ><CancelOutlined/> Discard</button>
                      </>
                    }
                    {/*
                    {voucherDetails.status === 1 && 
                      <button className='btn btn-outline-primary float-end ms-2' onClick={finalize} ><CheckCircle/> Finalize</button>
                    }

                    {voucherDetails.status === 3 && 
                      <button className='btn btn-outline-danger ms-2'> Discarded Challan <CancelOutlined/> </button>
                    }
                    */}

                    <button className='btn btn-outline-primary float-end ms-2' onClick={printVoucher} ><Print/> Print</button>

                    {voucherDetails && voucherDetails.status === 2 &&
                      <button >Covert To Sale / Purchase</button>
                    }
                    
                  </div>
                </div>
                <div ref={printComponentRef} >
                  <div className='row'>
                    <div className='col-md-12'>
                      {(voucherDetails.voucherType === "ChallanIn" ) &&
                        <PurchaseVoucherHeader
                          voucherDetails={voucherDetails}
                          companyDetails={companyDetails}
                          setCompanyDetails={setCompanyDetails}
                          partyDetails={partyDetails}
                          setPartyDetails={setPartyDetails}
                          callBack={getVoucherDetails}
                        />
                      }
                      {(voucherDetails.voucherType === "ChallanOut" ) &&
                        <SalesVoucherHeader 
                          voucherDetails={voucherDetails}
                          companyDetails={companyDetails}
                          setCompanyDetails={setCompanyDetails}
                          partyDetails={partyDetails}
                          setPartyDetails={setPartyDetails}
                          callBack={getVoucherDetails}
                        />
                      }
                    </div>

                    <div className='col-md-12 mt-2'>
                      {voucherDetails.voucherType === 'ChallanIn' ?

                        <VoucherInItemList
                          voucherDetails={voucherDetails} productList={productList} isPrinting={isPrinting} companyDetails={companyDetails}
                        />
                        :
                        <VoucherOutItemList
                          voucherDetails={voucherDetails} productList={productList} isPrinting={isPrinting} companyDetails={companyDetails}
                        />
                      }
                    </div>

                    <div className='col-md-12 mt-2'>
                      <VoucherFooter
                        voucherDetails={voucherDetails}
                        companyDetails={companyDetails}
                        partyDetails={partyDetails}
                      />
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        }
    </FinanceLayout>
  )
}

export default ChallanVoucherDetailsPage